import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';

const PlaceholderThumbnail = ({
	keyName,
	index
}) => {
	return (
		<div
			className={setClassNames([
				'bg-contrast-med'
			])}
			data-testid={`${keyName}-placeholder-${index}`}
			aria-hidden="true"
			style={{
				aspectRatio: 'auto 4 / 3'
			}}
		/>
	);
};

PlaceholderThumbnail.propTypes = {
	keyName: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired
};

export default PlaceholderThumbnail;
